import { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const CarOutlineIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <path
        data-cap="butt"
        d="M28,14,26.279,3.671A2,2,0,0,0,24.306,2H7.694A2,2,0,0,0,5.721,3.671L4,14"
        fill="none"
        stroke={color}
        strokeMiterlimit="10"
        strokeWidth="2.4"
      />
      <polyline
        data-color="color-2"
        points="9 27 9 30 3 30 3 27"
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2.4"
      />
      <polyline
        data-color="color-2"
        points="29 27 29 30 23 30 23 27"
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2.4"
      />
      <path
        d="M31,24H1V17.83a2,2,0,0,1,.585-1.414L4,14H28l2.414,2.414A2,2,0,0,1,31,17.828Z"
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit="10"
        strokeWidth="2.4"
      />
      <circle data-stroke="none" cx="6.5" cy="19.5" r="1.5" fill={color} />
      <circle data-stroke="none" cx="25.5" cy="19.5" r="1.5" fill={color} />
    </svg>
  );
};
